// extracted by mini-css-extract-plugin
module.exports = {"grid":"e_Um","leaderboard":"e_Vm"};